import { Fragment, useRef, useState, useEffect } from "react";
import { Dialog, Transition } from '@headlessui/react'
import ServerTable from "../../../components/atoms/tables/serverTable";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { debounce } from "lodash";
import { useStore } from "../../../store";
import InlineLoader from "../../../components/atoms/inlineLoader";
import Employees from "../../employees"
import Axios from "../../../AxiosConfig";
import swal from 'sweetalert';
const CompanyStatics = ({
    title,
    _key,
}) => {

    const { layoutStore } = useStore();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false)
    const [serverTableKey, setServerTableKey] = useState(0);
    const cancelButtonRef = useRef(null);
    const converKeyToFilter = (_key) => {
        switch (_key) {
            case "designation":
                return "designation";
            case "department":
                return "department";
            case "work-location":
                return "workLocation";
            case "source-of-hiring":
                return "sourceOfHiring";
            case "citizenship":
                return "citizenship";
            default:
                return "";
        }
    };
    const columns = [
        {
            name: title,
            selector: "name",
            sortable: true,
            sortField: "name",
            cell: (row) => (
                <span className="cursor-pointer underline" onClick={() => {
                    setSelectedFilter({
                        [converKeyToFilter(_key)]: row.name
                    })
                    setView("employees");
                }}>
                    {row.name}
                </span>
            )
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="flex justify-end">
                    <button
                        className="text-gray-600 hover:text-gray-900 font-semibold rounded-full hover:bg-gray-500 hover:text-white p-1"
                        onClick={() => {
                            setSelectedFilter({
                                [converKeyToFilter(_key)]: row.name
                            })
                            setView("employees");
                        }}
                    >
                        View Employees
                    </button>
                    <button
                        className="text-red-600 hover:text-red-900 ml-1 font-semibold rounded-full hover:bg-red-500 hover:text-white p-1"
                        // popup confirm
                        onClick={() => {
                            swal({
                                text: `Are you sure you want to delete this ${title}?`,
                                icon: "warning",
                                buttons: true,
                                dangerMode: true,
                            })
                            .then((willDelete) => {
                                if (willDelete) {
                                    Axios.post(`/company/${_key}/delete`, {
                                        name: row.name
                                    }).then((res) => {
                                        if (res.data.success) {
                                            layoutStore.showToaster(`${title} Deleted`, "success");
                                            setServerTableKey(serverTableKey + 1);
                                        }
                                        else {
                                            layoutStore.showToaster(res.data.error, "error");
                                        }
                                    })
                                }
                            });

                            // let confirm = window.confirm(`Are you sure you want to delete this ${title} ?`);
                            // if (confirm) {
                            //     Axios.post(`/company/${_key}/delete`, {
                            //         name: row.name
                            //     }).then((res) => {
                            //         if (res.data.success) {
                            //             layoutStore.showToaster(`${title} Deleted`, "success");
                            //             setServerTableKey(serverTableKey + 1);
                            //         }
                            //         else {
                            //             layoutStore.showToaster(res.data.error, "error");
                            //         }
                            //     })
                            // }
                        }}
                    >
                        Delete
                    </button>
                </div>
            )
        }
    ]
    const [query, setQuery] = useState("");
    const [filters, setFilters] = useState({});
    const [_view, setView] = useState("overview");
    const [selectedFilter, setSelectedFilter] = useState({});
    useEffect(() => {
        if (query.length > 0) {
            debounce(() => {
                setFilters({ query });
            }, 500)();
        }
        else {
            debounce(() => {
                setFilters({});
            }, 500)();
        }
    }, [query]);
    return (
        <>

            {_view === "overview" && (
                <div>
                    <div className="text-right">
                        <div className="my-1 flex rounded-md shadow-sm">
                            <div className="relative flex flex-grow items-stretch focus-within:z-10">
                                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                    <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                </div>
                                <input
                                    type="search"
                                    name="search"
                                    onChange={(e) => setQuery(e.target.value)}
                                    className="block w-full rounded-l-md border-gray-300 hover:border-blue-500 pl-10 mr-px focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    placeholder="Search..."
                                />
                            </div>
                            <span className="isolate inline-flex rounded-md shadow-sm">
                                <button
                                    type="button"
                                    className="inline-flex items-center rounded-r-md border border-transparent bg-blue-600 px-3 py-2 ml-px text-sm font-medium leading-4 text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                    onClick={() => setOpen(true)}

                                >
                                    Add {title}
                                </button>
                            </span>
                        </div>
                    </div>
                    <div>
                        <ServerTable
                            key={JSON.stringify(filters) + serverTableKey.toString()}
                            apiURL={`/company/${_key}/search`}
                            columns={columns}
                            filters={filters}
                        />
                    </div>
                </div>
            )}
            {_view === "employees" && (
                <div>
                    <div className="text-left border-b mb-3 pb-2">
                        <button
                            type="button"
                            onClick={() => setView("overview")}
                            className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            &lt; Back
                        </button>
                    </div>
                    <Employees
                        hardFilters={selectedFilter}
                    />
                </div>
            )}
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            let data = new FormData(e.target);
                                            setLoading(true);
                                            Axios.post(`/company/${_key}/create`, {
                                                "name": data.get('name'),
                                            }).then((res) => {
                                                if (res.data.success) {
                                                    layoutStore.showToaster(`${title} Added`, "success");
                                                    setServerTableKey(serverTableKey + 1);
                                                }
                                                else {
                                                    layoutStore.showToaster(res.data.error, "error");
                                                }
                                                setLoading(false);
                                                setOpen(false);
                                            });
                                        }}

                                    >
                                        <div>
                                            <div className="mt-3 text-center sm:mt-5">
                                                <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                                                    Add {title}
                                                </Dialog.Title>
                                                <div className="mt-2 text-left">
                                                    <div>
                                                        <div className="mt-1">
                                                            <input
                                                                type="text"
                                                                name="name"
                                                                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                                placeholder={`${title} Name`}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                            <button
                                                type="submit"
                                                className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
                                            >
                                                {loading ? <>Adding <InlineLoader /></> : `Add ${title}`}
                                            </button>
                                            <button
                                                type="button"
                                                className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
                                                onClick={() => setOpen(false)}
                                                ref={cancelButtonRef}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    )
}
export default CompanyStatics;